class ConcurrencyService {
  /**
   * Map the values, concurrently, to the callback result
   *
   * @param {Array} values
   * @param {Promise<Function>} callback
   * @param {Object} options
   * @param {Number} options.concurrency
   */
  async map (values, callback, { concurrency = 10 }) {
    const iterators = Array(concurrency).fill(values.entries())
    const results = []
    const asyncIterators = iterators.map(async (iterator) => {
      for (let [index, value] of iterator) {
        results[index] = await callback(value, index)
      }
    })

    await Promise.all(asyncIterators)

    return results
  }
}

export const concurrencyService = new ConcurrencyService()
